package com.yogaaicoach.pages.workout.data.models

import com.yogaaicoach.common.network.serializers.UuidSerializer
import kotlinx.serialization.Serializable
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

data class WorkoutData(
    val exercises: List<Exercise>,
    val sections: List<WorkoutProgressSectionDto>,
)

@OptIn(ExperimentalUuidApi::class)
@Serializable
data class Exercise(
    val baseData: ExerciseResponse,
    @Serializable(with = UuidSerializer::class) val workoutExerciseGuid: Uuid,
    val exerciseNumber: Int,
    val durationInSeconds: Int,
    val repetitions: Int,
    val isCompleted: Boolean,
    val endAudioFileName: String?,
    val endAudioLength: Int?,
    val sectionIndex: Int,
)

@OptIn(ExperimentalUuidApi::class)
@Serializable
data class ExerciseResponse(
    @Serializable(with = UuidSerializer::class) val exerciseGuid: Uuid,
    val name: String,
    val sanskritName: String?,
    val isOtherSide: Boolean,
    val exerciseDescription: String?,
    val video: MediaNarrowResponse,
    val audio: MediaNarrowResponse
)
@Serializable
data class MediaNarrowResponse(
    val filename: String,
    val duration: Int,
    val mediaAction: ExerciseMediaActionResponse?,
    val introFilename: String? = null,
    val introDuration: Int? = null,
    val outroFilename: String? = null,
    val outroDuration: Int? = null,
    /** Seconds to hold the first frame before playback starts. The exercise timer is frozen for this long too. */
    val startFreezeSeconds: Int? = null,
)

@Serializable
data class ExerciseMediaActionResponse(
    val startTime: Int,
    val endTime: Int,
    val action: ActionType
)

enum class MediaType {
    VIDEO,
    AUDIO;
}

enum class ActionType {
    CHANGE_SPEED,
    REPEAT,
    PAUSE,
    SLOW;
}